export default "__VITE_ASSET__ffb22f9f__"